// @flow

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const DEBUG = false;

type ContactCardProps = {
	hiddenClass: string,
	showOn: string,
	closeEvent: string,
};

const fragments = {
	CONTENT: '[data-fragment="ContactCard.content"]',
	CLOSE:   '[data-fragment="ContactCard.close"]',
};

/**
 * Komponenta pro praci s image mapou
 */
class ContactCard extends WebComponent {

	defaultProps: ContactCardProps;
	props: ContactCardProps;
	objects: Object;
	element: HTMLElement;

	static defaultProps = {
		closeEvent:   'cardClosed',
		hiddenClass:  'hidden',
		messages: {
			'labelPhone': 'Telefon',
			'labelMobile': 'Mobil',
			'labelEmail': 'E-mail',
		},
	};

	constructor(props: ?ContactCardProps) {
		super(props);

		this.showCard = this.showCard.bind(this);
		this.closeCard = this.closeCard.bind(this);

		clog(this);
	}

	didMount() {
		clog('did mount');
		this.bindListeners();
		this.element.classList.add(this.props.hiddenClass);
	}

	willUnMount() {
		document.removeEventListener(this.props.showOn, this.showCard);
	}

	bindListeners() {
		clog('binding');
		clog(this.props);
		document.addEventListener(this.props.showOn, this.showCard);
		this.on('click', fragments.CLOSE, this.closeCard);
	}

	createCard({
		           name,
		           photosSrc,
		           phone,
		           email,
		           mobile,
	           }) {
		return `<h4 class="contact-card__name">${ name }</h4>`
			+ `<p class="contact-card__photo"><img src="${ photosSrc }" alt="${ name }" /></p>`
			+ ( phone ? `<p class="contact-card__contact"><span class="contact-card__label">${ this.i18n('labelPhone') }:</span> <span class="phone-number">${ formatPhone(phone) }</span></p>` : '' )
			+ ( mobile ? `<p class="contact-card__contact"><span class="contact-card__label">${ this.i18n('labelMobile') }:</span> <span class="phone-number">${ formatPhone(mobile) }</span></p>` : '' )
			+ ( email ? `<p class="contact-card__contact"><span class="contact-card__label">${ this.i18n('labelEmail') }:</span> <a href="mailto:${ email }">${ email }</a></p>` : '' );
	}

	showCard(event: ?SyntheticEvent<CustomEvent>) {
		clog('showing contact card');
		try {
			let cardData = event.detail.dataset.manager.replace(/'/g, '"');
			cardData = JSON.parse(cardData);
			// create new card from template
			// append it into wrapper
			const content = this.element.querySelector(fragments.CONTENT);
			if ( content instanceof HTMLDivElement ) {
				content.innerHTML = this.createCard(cardData);
			}
			clog(this.element);
			// show it
			this.element.classList.remove(this.props.hiddenClass);
		} catch ( e ) {
			this.closeCard();
			// console.error(e);
			throw new Error('ContactCard does not have necessary data');
		}
	}

	closeCard() {
		clog('closing card');
		this.element.classList.add(this.props.hiddenClass);
		const publicEvent = new CustomEvent(this.props.closeEvent);
		document.dispatchEvent(publicEvent);

	}

}

export default ContactCard;

// simple logger
function clog(...args: any): void {
	if ( window.console && DEBUG ) {
		/* eslint-disable no-alert, no-console */
		console.group('Debug of ContactCard');
		Object.values(args).forEach(value => console.log(value));
		console.groupEnd();
		/* eslint-enable no-alert, no-console */
	}
}

const formatInteger = (input) => {
	input = input.toString();
	return input.replace( /((?=(\d{7,9}))((\d{0,3})?(\d{3})?(\d{3})?(\d{3})?(\d{3})))$/g, '$4 $5 $6 $7 $8').replace(/(^\s*)|(\s*$)/g, '');
};

const formatPhone = (phone) => {
	phone = phone.toString();
	let formatted;
	if ( phone.match(/^\+/) ) {
		phone = phone.substr(1);
		formatted = `+${ formatInteger(phone) }`;
	} else {
		formatted = formatInteger(phone);
	}
	return formatted;
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ContactCard.js